import '../../sass/pages/_activityDetail.scss'

// Import Drupal
declare var drupalSettings: any;

// Impor GMaps
declare var google: any;

// Import API
import { apiService } from '../services/api'
const api = new apiService();

// Import Swiper
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// Import Components
import SplitText from '../components/SplitText'

import * as Bouncer from 'formbouncerjs'
const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com']


declare global {
    interface Window {
        dataLayer: any
    }
}


const Detail = () => {
    modalToggle()
    printPhotos()
    toggleCardMobile()
    infoCard()
    setSplitText()
    modalInscription()
    confirmDeleteActivity()
    updatePhotos()
    validateForm()
    
    setTimeout(() => {
        openPhotosModal()
        closeModalExitoso()
        openModalGallery()
    }, 2000);
}

(function page() {
	Detail()
})()

async function photosActividad() {
    let nodeID = drupalSettings.path.currentPath;
    return new Promise(async (resolve: any) => {
        const request = await api.getPhotosActivity(nodeID)
        resolve(request)
    })
}

function printPhotos() {
    const sectionGallery = document.querySelector('.mvm-activityDetail__gallery') as HTMLElement
    const gallery = sectionGallery.querySelector('.mvm-activityDetail__gallery-box') as HTMLElement
    const modalContent = document.querySelector('.mvm-activityDetail__modal__gallery .swiper-wrapper') as HTMLElement

    gallery.innerHTML = ''
    modalContent.innerHTML = ''

    photosActividad().then(function (data: any) {
        if(data == 'NO hay fotos para la actividad') {
            sectionGallery.classList.add('hidden')
        }

        else {
            let info = data.response
    
            for (let i = 0; i < 4; i++) {
                if (info[i]) {
                    const img = document.createElement('img');
                    img.className = 'image';
                    img.src = info[i].url;
                    img.alt = '';
                    gallery.appendChild(img);
                }
            }

            info.forEach((element: any) => {
                const swiperSlide = document.createElement('div');
                swiperSlide.className = 'swiper-slide';

                const itemRed = document.createElement('div');
                itemRed.className = 'item-red';
                itemRed.textContent = element.volunteer;

                const imgElement = document.createElement('img');
                imgElement.className = 'image';
                imgElement.src = element.url;
                imgElement.alt = '';

                swiperSlide.appendChild(itemRed);
                swiperSlide.appendChild(imgElement);

                modalContent.appendChild(swiperSlide);
            });
        }
    })
}

function closeModalExitoso() {
    const modalUpload = document.querySelector('.mvm-modal--white[data-modal="subir-fotos-exitoso"]')
    
    if(modalUpload) {
        const closeModal = modalUpload?.querySelector('.mvm-modal-close')
        const aceptModal = modalUpload?.querySelector('.btn--solidRed')

        if(!modalUpload?.classList.contains('is-close')) {
            document.querySelector('body')?.classList.add('noScroll')
        }

        closeModal?.addEventListener('click', function () {
            modalUpload?.classList.add('is-close')
            document.querySelector('body')?.classList.remove('noScroll')
            location.reload()
        })
    
        aceptModal?.addEventListener('click', function () {
            modalUpload?.classList.add('is-close')
            document.querySelector('body')?.classList.remove('noScroll')
            location.reload()
        })
    }

}

function validateForm() {
    let validate = Bouncer('#upload-fotos--2', {
        customValidations: {
            imageSizeVerified: function ({ name, value, files }: any) {
                let filesNo = 0;
                if (name == "imagen[]" && value.length != 0) {
                    Array.from(files).forEach((element: any) => {
                        if (element.size > 500000) {
                            filesNo ++;
                        }
                    });

                    if (filesNo > 0) {
                        return true;
                    }
                }
            },

            limitFiles: function ({ name, value, files }: any) {
                if (name == "imagen[]" && files.length > 3) {
                    return true;
                }
            },
        },
        messages: {
            missingValue: {
                default: 'Este campo es requerido.'
            },
            imageSizeVerified : 'Alguno de los archivos pesa más de 500KB',
            limitFiles: 'Solo puedes subir 3 imágenes',
        }
    })
}

function formatSizeUnits(bytes: any){
    if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1)           { bytes = bytes + " bytes"; }
    else if (bytes == 1)          { bytes = bytes + " byte"; }
    else                          { bytes = "0 bytes"; }
    return bytes;
}

function updatePhotos() {
    const modalContent = document.querySelector('.mvm-activityDetail__modal__upload') as HTMLElement
    const inputFile = modalContent?.querySelector('#edit-imagen-upload') as any
    const boxImages = modalContent?.querySelector('.form__box') as HTMLElement

    inputFile?.addEventListener('change', (e: any) => {
        let fileList = inputFile.files
        boxImages.innerHTML = ''
        
        if (fileList.length > 0) {
            Array.from(fileList).forEach((element: any) => {
                let url = URL.createObjectURL(element)
                let size = element.size

                const container = document.createElement('div');
                container.className = 'form__image';

                const infoDiv = document.createElement('div');
                infoDiv.className = 'form__image__info';

                const imageDiv = document.createElement('div');
                imageDiv.className = 'image';
                const img = document.createElement('img');
                img.src = url;
                img.alt = '';
                imageDiv.appendChild(img);

                const infoContentDiv = document.createElement('div');
                infoContentDiv.className = 'info';

                const nameDiv = document.createElement('div');
                nameDiv.className = 'info__name bold_18';
                nameDiv.textContent = element.name;

                const sizeDiv = document.createElement('div');
                sizeDiv.className = 'info__size medium_18';
                sizeDiv.textContent = formatSizeUnits(size);

                infoContentDiv.appendChild(nameDiv);
                infoContentDiv.appendChild(sizeDiv);

                infoDiv.appendChild(imageDiv);
                infoDiv.appendChild(infoContentDiv);

                const controlsDiv = document.createElement('div');
                controlsDiv.className = 'form__image__controls';

                const correctDiv = document.createElement('div');
                correctDiv.className = 'correct';

                const deleteDiv = document.createElement('div');
                deleteDiv.className = 'delete';
                deleteDiv.dataset.delete = element.name;

                controlsDiv.appendChild(correctDiv);
                controlsDiv.appendChild(deleteDiv);

                container.appendChild(infoDiv);
                container.appendChild(controlsDiv);

                boxImages.appendChild(container);
            });

            boxImages.addEventListener('click', (e: any) => {
                let target = e.target
                const dataTransfer = new DataTransfer()
                
                if(target.classList.contains('delete')) {
                    target.closest('.form__image').remove()
                    
                    Array.from(fileList).forEach((element: any) => {
                        let dataDelete = target.dataset.delete
                        
                        if(element.name == dataDelete) {
                            return
                        }
                        
                        const file = new File([element], element.name, {type: element.type})
                        
                        dataTransfer.items.add(file)
                    })

                    inputFile.files = dataTransfer.files
                }
            })
        }
    })
}

function openPhotosModal() {
    const openModal = document.querySelector('.card-buttons--finalizado .btn--solidRed') as HTMLElement
    const dataModal = openModal.dataset.modal
    const modalUpload = document.querySelector(`.mvm-modal--white[data-modal="${dataModal}"]`)
    const closeModal = modalUpload?.querySelector('.mvm-modal-close')
    const formModal = modalUpload?.querySelector('#upload-fotos--2') as any
    const boxImages = modalUpload?.querySelector('.form__box') as HTMLElement

    openModal?.addEventListener('click', function () {
        modalUpload?.classList.remove('is-close')
        document.querySelector('body')?.classList.add('noScroll')
    })

    closeModal?.addEventListener('click', function () {
        modalUpload?.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
        formModal.reset()
        boxImages.innerHTML = ''
    })
}

function openModalGallery() {
    const openModal = document.querySelector('.mvm-activityDetail__gallery .btn--solidWhite')
    const modalGallery = document.querySelector('.mvm-modal--swiper')
    const closeModal = modalGallery?.querySelector('.mvm-modal-close')

    openModal?.addEventListener('click', function () {
        modalGallery?.classList.remove('is-close')
        document.querySelector('body')?.classList.add('noScroll')
    })
    
    setSwiper()
    
    closeModal?.addEventListener('click', function () {
        modalGallery?.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
    })
}

function setSwiper() {
    const swiperModal = new Swiper('.swiper-modal', {
        modules: [ Navigation, Pagination ],
        spaceBetween: 30,
        speed: 1000,
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number: any) {
                if (number <= '9') {
                    return '0' + number;
                } 
                
                else {
                    return number
                }
            },
            formatFractionTotal: function (number: any) {
                if (number <= '9') {
                    return '0' + number;
                } 
                
                else {
                    return number
                }
            },
        },
    })
}

function setSplitText() {
    new SplitText('.mvm-activityDetail__head-info .title')
    new SplitText('.subtitleSmall')
}

async function deleteActividad() {
    let nodeID = drupalSettings.path.currentPath;
    return new Promise(async (resolve: any) => {
        const request = await api.deleteActivity(nodeID)
        resolve(request)
    })
}

async function unsuscribeActivity(){
    let nodeID = drupalSettings.path.currentPath;
    return new Promise(async (resolve: any) => {
        const request = await api.unsuscribeActivity(nodeID)
        resolve(request)
    })
}

function confirmDeleteActivity() {
    const cardInscrito = document.querySelector('.card-buttons--inscrito') as HTMLElement
    const cancelarInscripcion = cardInscrito.querySelector('.btn--borderRed') as HTMLElement
    const cardInstitucion = document.querySelector('.card-buttons--institucionEliminar') as HTMLElement
    const eliminarActividad = cardInstitucion.querySelector('.btn--borderRed') as HTMLElement
    const modalDelete = document.querySelector('.mvm-modal--white[data-modal="confirmar-eliminar"]') as HTMLElement
    const close = modalDelete.querySelector('.mvm-modal-close') as HTMLElement
    const buttonYes = modalDelete.querySelector('.btn--borderRed') as HTMLElement
    const buttonNo = modalDelete.querySelector('.btn--solidRed') as HTMLElement
    const title = modalDelete.querySelector('.subtitleSmall') as HTMLElement
    const description = modalDelete.querySelector('.medium_22') as HTMLElement

    cancelarInscripcion.addEventListener('click', () => {
        modalDelete.classList.remove('is-close')
        document.querySelector('body')?.classList.add('noScroll')
        title.textContent = '¿Quieres cancelar tu inscripción?'
        description.textContent = 'Tu inscripción en esta actividad será eliminada, ¿estás seguro de realizar está acción?'

        buttonYes.addEventListener('click', () => {
            unsuscribeActivity()
            location.reload()
        })
    })

    eliminarActividad.addEventListener('click', () => {
        modalDelete.classList.remove('is-close')
        document.querySelector('body')?.classList.add('noScroll')
        title.textContent = '¿Quieres eliminar esta actividad?'
        description.textContent = 'Esta actividad será eliminada permanentemente, ¿estás seguro de realizar está acción?'

        buttonYes.addEventListener('click', () => {
            deleteActividad()
            location.pathname = '/actividades-institucion'
        })
    })

    buttonNo.addEventListener('click', function () {
        modalDelete.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
    })

    close.addEventListener('click', function () {
        modalDelete.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
    })
}

async function registred(){
    let nodeID = drupalSettings.path.currentPath;
    return new Promise(async (resolve: any) => {
        const request = await api.registedActivity(nodeID)
        resolve(request)
    })
}

function modalInscription() {
    const modalInscription = document.querySelector('.mvm-modal--white[data-modal="registro-exitoso"]') as HTMLElement
    const qrSrc = modalInscription.querySelector('.mvm-activityDetail__modal-qr .image img') as HTMLElement
    const close = modalInscription.querySelector('.mvm-modal-close') as HTMLElement
    const button = modalInscription.querySelector('.mvm-activityDetail__modal-btn') as HTMLElement
    const buttonIncribir = document.querySelector('.card-buttons--inicial .btn--solidRed') as HTMLElement
    const buttonIncribir2 = document.querySelector('.mvm-activityDetail__btn') as HTMLElement

    buttonIncribir.addEventListener('click', function () {
        registred().then(function (data: any) {
            if (data != 'Usuario no autenticado') {
                qrSrc.setAttribute('src', data.UrlQr)
                modalInscription.classList.remove('is-close')
                document.querySelector('body')?.classList.add('noScroll')
            }

            else {
                location.href = '/inicio-voluntario'
            }
        })
    })

    buttonIncribir2.addEventListener('click', function () {
        registred().then(function (data: any) {
            if (data != 'Usuario no autenticado') {
                qrSrc.setAttribute('src', data.UrlQr)
                modalInscription.classList.remove('is-close')
                document.querySelector('body')?.classList.add('noScroll')
            }

            else {
                location.href = '/inicio-voluntario'
            }
        })
    })

    close.addEventListener('click', function () {
        modalInscription.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
        location.reload()
    })

    button.addEventListener('click', function () {
        modalInscription.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
        location.reload()
    })
}

async function getDetail(){
    let nodeID = drupalSettings.path.currentPath;
    return new Promise(async (resolve: any) => {
        const request = await api.activityDetail(nodeID)
        resolve(request)
    })
}

function infoCard() {
    const headBg = document.querySelector('.mvm-activityDetail__headBg')
    const alertDaysBg = document.querySelector('.alertDays')
    const videoBg = document.querySelector('.mvm-activityDetail__video')
    const qrBg = document.querySelector('.mvm-activityDetail__modal-qrBg')
    const card = document.querySelector('.card') as HTMLElement

    const stateVoluntario = card.querySelector('.card-state-volunta') as HTMLElement

    const stateInstitucion = card.querySelector('.card-status-insti') as HTMLElement
    const itemState = stateInstitucion.querySelector('.item-red') as HTMLElement

    const goal = card.querySelector('.card-meta') as HTMLElement
    const textGoal = goal.querySelector('#text-goal') as HTMLElement
    const inscritosGoal = goal.querySelector('#voluntarios-inscritos') as HTMLElement
    const progressGoal = goal.querySelector('#barra-progreso') as HTMLElement
    const goalBox = goal.querySelector('#goal-voluntarios') as HTMLElement

    const startDate = card.querySelector('.start-date') as HTMLElement
    const startDateInfo = startDate.querySelector('#card_start_date') as HTMLElement
    const startTimeInfo = startDate.querySelector('#card_start_time') as HTMLElement
    const endDate = card.querySelector('.end-date') as HTMLElement
    const endDateInfo = endDate.querySelector('#card_end_date') as HTMLElement
    const endTimeInfo = endDate.querySelector('#card_end_time') as HTMLElement
    
    const imageOrganizador = card.querySelector('#image-organizador') as HTMLElement
    const nameOrganizador = card.querySelector('#name-organizador') as HTMLElement
    const nameCoordinador = card.querySelector('#name-coordinador') as HTMLElement
    const emailCoordinador = card.querySelector('#email-coordinador') as HTMLElement

    const mail = card.querySelector('#mail') as HTMLElement
    const phone = card.querySelector('#phone') as HTMLElement
    const website = card.querySelector('#website') as HTMLElement

    const tipeVolunter = card.querySelector('#tipoVoluntariado') as HTMLElement

    const buttonsInitial = card.querySelector('.card-buttons--inicial') as HTMLElement
    const buttonDonate = buttonsInitial.querySelector('.btn--borderRed')
    const buttonIncribir = buttonsInitial.querySelector('.btn--solidRed') as HTMLElement
    const buttonIncribir2 = document.querySelector('.mvm-activityDetail__btn') as HTMLElement
    const buttonsInscrito = card.querySelector('.card-buttons--inscrito') as HTMLElement
    const buttonsFinalizado = card.querySelector('.card-buttons--finalizado') as HTMLElement
    const buttonsIntitucion = card.querySelector('.card-buttons--institucion') as HTMLElement
    const buttonsIntitucionDelete = card.querySelector('.card-buttons--institucionEliminar') as HTMLElement

    getDetail().then(function (data: any) {
        let info = data.response

        startDateInfo.textContent = info.start_date
        startTimeInfo.textContent = info.start_time

        imageOrganizador.setAttribute('src', info.institution_image)
        nameOrganizador.textContent = info.institution_name
        nameCoordinador.textContent = info.coordinator_name
        emailCoordinador.textContent = info.coordinator_mail

        mail.textContent = info.institution_mail
        phone.textContent = info.institution_phone
        website.textContent = info.institution_website

        tipeVolunter.textContent = info.modality
        
        if (info.user_type == 'volunteer' && info.registred == 1) {
            if(info.activity_status == '3') {
                const finalizadoDiv = document.createElement('div');
                finalizadoDiv.className = 'subtitleSmall';
                finalizadoDiv.textContent = 'El evento ha finalizado';

                stateVoluntario.textContent = '';
                stateVoluntario.appendChild(finalizadoDiv);
                stateVoluntario.classList.remove('hidden');

                buttonsFinalizado.textContent = '';
                buttonsFinalizado.classList.remove('hidden');

                const subirFotosLink = document.createElement('a');
                subirFotosLink.className = 'btn--solidRed';
                subirFotosLink.dataset.modal = 'subir-fotos';
                subirFotosLink.textContent = 'Sube tus fotos';

                buttonsFinalizado.appendChild(subirFotosLink);
            }
            
            else {
                stateVoluntario.classList.remove('hidden')
                buttonsInscrito.classList.remove('hidden')
            }
        }
        
        else if (info.user_type == 'institution') {
            stateInstitucion.classList.remove('hidden')

            if (info.activity_status == '1') {
                itemState.classList.add('item-green')
                itemState.textContent = 'Publicado'

                if (info.user == info.id_institucion) {
                    buttonsIntitucion.classList.remove('hidden')
                }
            }

            else if (info.activity_status == '0') {
                itemState.classList.add('item-yellow')
                itemState.textContent = 'En revisión'

                if (info.user == info.id_institucion) {
                    buttonsIntitucionDelete.classList.remove('hidden')
                    document.querySelector('.redes-sociales')?.classList.add('disabled')
                }
            }

            else if (info.activity_status == '3') {
                itemState.classList.add('item-gray')
                itemState.textContent = 'Finalizado'

                if (info.user == info.id_institucion) {
                    buttonsIntitucion.classList.remove('hidden')
                    document.querySelector('.redes-sociales')?.classList.add('disabled')
                }
            }
        }
        
        else if (info.user_type == null || info.registred == 0) {
            if(info.activity_status != '3') {
                buttonsInitial.classList.remove('hidden')
                buttonIncribir2.classList.remove('hidden')
            }
        }

        if (info.goal_volunters == '0' || info.ilimited == '1') {
            goal.classList.add('hidden')
        }

        else {
            inscritosGoal.textContent = info.registred_volunters
            progressGoal.setAttribute('value', info.registred_volunters)
            progressGoal.setAttribute('max', info.goal_volunters)
            goalBox.textContent = `Meta: ${info.goal_volunters}`
            
            if(info.activity_status == '3') {
                textGoal.textContent = 'Voluntarios que asistieron'
            }

            if (info.registred_volunters == info.goal_volunters) {
                buttonIncribir.classList.add('hidden')
                buttonIncribir2.classList.add('hidden')
            }
        }

        if (info.end_date == '') {
            endDate.classList.add('hidden')
            document.querySelector('.dates__end')?.classList.add('hidden')
        }

        else {
            endDateInfo.textContent = info.end_date
            endTimeInfo.textContent = info.end_time
        }

        if(info.donate == '0') {
            buttonDonate?.classList.add('hidden')
        }

        if (info.category == 'Apoyo a la educación' || info.category == 'Ayuda comunitaria' || info.category == 'Reactivación económica' || info.category == 'Emprendimiento social' || info.category == 'Empoderamiento de la mujer' || info.category == 'Capacitación en línea') {
            headBg?.classList.add('orange')
            alertDaysBg?.classList.add('orange')
            videoBg?.classList.add('orange')
            qrBg?.classList.add('orange')
        }

        else if (info.category == 'Cuidado de recursos naturales' || info.category == 'Protección de la biodiversidad') {
            headBg?.classList.add('green')
            alertDaysBg?.classList.add('green')
            videoBg?.classList.add('green')
            qrBg?.classList.add('green')
        }

        else if (info.category == 'Salud y bienestar' || info.category == 'Consumo responsable' || info.category == 'Defensa de los Derechos Humanos') {
            headBg?.classList.add('purple')
            alertDaysBg?.classList.add('purple')
            videoBg?.classList.add('purple')
            qrBg?.classList.add('purple')
        }
    });
}

function toggleCardMobile() {
    const card = document.querySelector('.mvm-activityDetail__info .card') as HTMLElement;
    const showMore = card.querySelector('#more') as HTMLElement;
    const text = showMore.querySelector('.item') as HTMLElement;

    showMore.addEventListener('click', () => {
        if (card.classList.contains('active')) {
            card.classList.remove('active')
            text.textContent = 'Ver más'
        }

        else {
            card.classList.add('active')
            text.textContent = 'Ver menos'
        }
    })
}

function modalToggle() {
    const openModalButton = document.querySelector('.modal-open') as HTMLElement;
    const videoId = openModalButton?.querySelector('iframe')?.dataset.src as String;
    let title = document.querySelector('.titleVideo')?.innerHTML
    window.dataLayer = window.dataLayer || [];
    if (openModalButton) {
        const idModal = openModalButton.getAttribute('data-modal') as String;
        const modal = document.querySelector(`.mvm-modal[data-modal="${idModal}"]`) as HTMLElement;
        if (modal) {
            const close = modal.querySelector('.mvm-modal-close') as HTMLElement;
            const videos = modal.querySelectorAll('iframe');
            
            openModalButton.addEventListener('click', function () {
                if(videos) {
                    videos.forEach((video: any) => {
                        video.src = `https://www.youtube.com/embed/${videoId}`
                    })
                }

                if (modal) {
                    modal.classList.remove('is-close');
                    document.querySelector('body')?.classList.add('noScroll')
                }
                window.dataLayer.push({ 
                    'event': 'GAEvent', 
                    'event_category': 'Video', 
                    'event_action': 'play', 
                    'event_label': `${title}`,
                    'interaction':'true',
                });
            })
    
            if (modal && close) {
                close.addEventListener("click", function () {
                    modal.classList.add("is-close");
                    document.querySelector('body')?.classList.remove('noScroll')
    
                    if (videos) {
                        videos.forEach((video: any) => {
                            video.src = ''
                        })
                    }
                })
            }
        }
    }
}